import React, { useEffect } from 'react';
import { uniqueId } from 'lodash';
import {
  StyledTabs,
  StyledTab,
} from 'components/GlobalLegalProceedingTabs/style';

export interface GlobalLegalProceedingTabsProps {
  children?: React.ReactNode[];
  labels: string[];
  currentTabIndex: number;
  onTabClick?: Function;
  setCurrentInstanceTab?: Function;
  onPressFeeNote?: () => void;
}

const GlobalLegalProceedingTabs: React.FC<GlobalLegalProceedingTabsProps> = (
  props,
): JSX.Element => {
  const { currentTabIndex, children, labels, onTabClick } = props;

  const [currentTab, setCurrentTab] = React.useState<number>(currentTabIndex);
  useEffect(() => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(currentTabIndex);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex, onTabClick]);

  const handleChangeTab = (event: React.ChangeEvent<{}>, newTab: number) => {
    if (onTabClick) onTabClick(currentTab);
    setCurrentTab(newTab);
  };

  return (
    <>
      <StyledTabs value={currentTab} onChange={handleChangeTab}>
        {React.Children.toArray(children).map((_, index) => (
          <StyledTab key={uniqueId('sahamtab')} label={labels[index]} />
        ))}
      </StyledTabs>
      {React.Children.toArray(children)[currentTab]}
    </>
  );
};

export default GlobalLegalProceedingTabs;
